import React, {useState} from 'react';
import './Players.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { Card, Button } from 'react-bootstrap';

const Players = (props) => {
    const { name, image, salary, team_name } = (props.member)
    const [btnDisable, setBtnDisable] = useState(false);
    return (
                <Card className="player-card" >
                    <Card.Img variant="top" src={image} className="player_img" />
                    <Card.Body>
                        <Card.Title>Name: {name}</Card.Title>
                        <Card.Text>
                            <p>Salary:{salary}</p>
                            <p>Team Name:{team_name}</p>
                        </Card.Text>
                        <Button  className={btnDisable ? "add_btn disabled" : "add_btn"} variant="outline-primary"
                        onClick={() =>  {props.handleAddMember(props.member); setBtnDisable(true)}}
                        >Add Player <FontAwesomeIcon icon={ faPlusCircle} /></Button>
                    </Card.Body>
                </Card>
    );
};

export default Players;